import { NgModule } from '@angular/core';

import { BetaWarningComponent } from './beta-warning.component';
import { SharedModule }         from '../../shared/shared.module';

@NgModule({
  declarations: [
    BetaWarningComponent
  ],
  entryComponents: [
    BetaWarningComponent
  ],
  exports: [
    BetaWarningComponent
  ],
  imports: [
    SharedModule
  ]
})
export class BetaWarningModule {}
